import React from 'react';
import { observable, action } from 'mobx';
import { inject, observer } from 'mobx-react';

import { Form, Field, Select } from '@smartplatform/ui';

import t from '../../../i18n';
import data from '../../components/acls/data';

@inject('store', 'uiStore') @observer
class RoleMappingEdit extends React.Component {
	
	@observable record = null;
	@observable users = null;
	@observable isLoading = false;

	constructor (props) {
		super(props);
		this.store = props.store;
		this.props = props;

		props.uiStore.setBar(<h1>{t('RoleMapping.title')}</h1>);

		this.init();
	}

	@action init = async () => {
		this.isLoading = true;

		if (this.props.match.params.id) {
			this.record = await this.store.RoleMapping.findById(this.props.match.params.id);
		} else {
			this.record = new this.store.RoleMapping();
		}

		this.users = await this.store.User.find();
		this.isLoading = false;
	};

	back = () => {
		let rootPath = this.props.location.pathname || '';
		if (rootPath.length > 0) {
			rootPath = rootPath.replace(/\/$/, '');
		}
		this.props.history.push(`${rootPath}`);
	};

	render () {
		if (this.isLoading) return '...';

		const users = this.users.map(u => {
			const fio = ((u.lastName || '') + ' ' + (u.firstName || '') + ' ' + (u.middleName || '')).trim();
			const label = [fio, u.username, u.email || 'id: ' + u.id].filter(v => !!v).join(' / ');
			return { value: '' + u.id, label };
		});

		return !this.isLoading && (
			<Form
				record={this.record}
				stay
				onDelete={this.back}
				onSave={this.back}
			>
				<Field property="principalType" label={t('ACL.principalType')}>
					<Select items={data.PRINCIPAL_TYPE.map(pt => ({ value: pt.id, label: pt.name }))} />
				</Field>

				{this.record.principalType === 'USER' && this.users && (
					<Field property="principalId" label={t('User.title')}>
						<Select items={users} position="bottom" />
					</Field>
				)}

				<Field relation="role" property="name" label={t('Role.title')} />
			</Form>
		);
	}
}

export default RoleMappingEdit;
